import { render, staticRenderFns } from "./InvitacionQuiniela.vue?vue&type=template&id=1b513614&lang=pug"
import script from "./InvitacionQuiniela.vue?vue&type=script&lang=js"
export * from "./InvitacionQuiniela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports